import React from "react";

const RehabilitationPageTabs = ({ data }) => {
  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: data?.body }}></div>
    </>
  );
};

export default RehabilitationPageTabs;
